import React, { useContext, useEffect, useRef, useState } from "react";
import { ERROR_MESSAGES } from "../../../components/common/GlobalMassssage";
import SuccessModal from "../../../components/common/SuccessModal";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";
import {
  AddUpdateCountry,
  GetCountryModel,
} from "../../../services/Country/CountryApi";

const AddUpdateCountryModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
}) => {
  const inputRef = useRef(null);
  const ModuleName = "Predefined";
  const [formData, setFormData] = useState({
    countryName: "",
    countryCode: "",
    locale: "",
    currencyCode: "",
    currencySymbol: "",
  });
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    }
  }, [isOpen]);

  // Get Model
  useEffect(() => {
    setModelAction(modelRequestData.Action === null ? "Add" : "Update");
    if (
      modelRequestData.KeyID !== undefined &&
      modelRequestData.KeyID !== null &&
      modelRequestData.Action === "Update"
    ) {
      GetClientIndustryModelData(modelRequestData.KeyID);
    } else {
      setFormData({
        countryName: "",
        countryCode: "",
        locale: "",
        currencyCode: "",
        currencySymbol: "",
      });
    }
    setErrorMessage("");
  }, [modelRequestData]);

  if (!isOpen) return null;

  // Get Model Data
  const GetClientIndustryModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetCountryModel(
      ModuleName,
      KeyID,
      authDetails.adminKeyID
    );
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setFormData({
        countryName: ModalData.countryName,
        countryCode: ModalData.countryCode,
        locale: ModalData.locale,
        currencyCode: ModalData.currencyCode,
        currencySymbol: ModalData.currencySymbol,
      });
    } else {
      setLoader(false);
    }
  };

  const handleSubmit = async () => {
    const { countryName, countryCode, locale, currencyCode, currencySymbol } =
      formData;

    if (
      countryName === "" ||
      countryCode === "" ||
      locale === "" ||
      currencyCode === "" ||
      currencySymbol === ""
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await AddUpdateCountry({
        adminKeyID: authDetails.adminKeyID,
        countryName,
        countryCode,
        locale,
        currencyCode,
        currencySymbol,
        countryKeyID: modelRequestData.KeyID,
        ModuleName,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        setShowSuccessPopupModal(true);
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
      {/* Background Overlay */}
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>

      {/* Modal Box */}
      <div className="bg-white rounded-lg shadow-lg z-10 w-full max-w-[90%] sm:w-1/3">
        {/* Header */}
        <div className="bg-[#ECF6FF] px-6 py-4 rounded-t-lg border-b">
          <h2 className="text-sm sm:text-base font-semibold text-gray-800">
            {modelAction} Country
          </h2>
        </div>

        {/* Body Section */}
        <div className="p-6 sm:p-8 space-y-4">
          {/* Row for Country Name and Country Code */}
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Country Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                maxLength={20}
                type="text"
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter Country Name"
                value={formData.countryName}
                onChange={(e) => {
                  const value = e.target.value;

                  // Capitalize the first letter if the input is not empty
                  let formattedValue = value;
                  if (formattedValue.length > 0) {
                    formattedValue =
                      formattedValue.charAt(0).toUpperCase() +
                      formattedValue.slice(1);
                  }

                  // Allow only letters at the start, then letters & spaces after the first character
                  if (
                    /^[A-Za-z][A-Za-z\s]*$/.test(formattedValue) ||
                    formattedValue === ""
                  ) {
                    setFormData({ ...formData, countryName: formattedValue });
                  }
                }}
              />
              {requireErrorMessage && formData.countryName === "" && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Country Code <span style={{ color: "red" }}>*</span>
                <span className="text-gray-500 text-xs"> (e.g. +91)</span>
              </label>
              <input
                maxLength={5}
                type="text"
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter Country Code"
                value={formData.countryCode}
                onChange={(e) => {
                  let value = e.target.value;

                  // Allow only '+' at the start and numbers after that
                  value = value.replace(/[^0-9+]/g, ""); // Remove non-numeric, non-+ characters
                  value = value.replace(/(?!^)\+/g, ""); // Remove '+' if it's not at the beginning
                  value = value.replace(/^(\+\d*)?.*$/, "$1"); // Ensures format stays valid

                  setFormData({ ...formData, countryCode: value });
                }}
              />
              {requireErrorMessage && formData.countryCode === "" && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>
          </div>

          {/* Row for Locale and Currency Code */}
          <div className="flex space-x-4">
            {/* Locale Field */}
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Locale <span style={{ color: "red" }}>*</span>
                <span className="text-gray-500 text-xs"> (e.g.en-IN)</span>
              </label>
              <input
                maxLength={10}
                type="text"
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter Locale"
                value={formData.locale}
                onChange={(e) =>
                  setFormData({ ...formData, locale: e.target.value })
                }
              />
              {requireErrorMessage && formData.locale === "" && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>

            {/* Currency Code Field */}
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Currency Code <span style={{ color: "red" }}>*</span>
                <span className="text-gray-500 text-xs"> (e.g.INR)</span>
              </label>
              <input
                maxLength={10}
                type="text"
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter Currency Code"
                value={formData.currencyCode}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/[^a-zA-Z]/g, "")
                    .toUpperCase(); // Allow only uppercase letters
                  setFormData({ ...formData, currencyCode: value });
                }}
              />
              {requireErrorMessage && formData.currencyCode === "" && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>
          </div>

          {/* Row for Currency Symbol */}
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Currency Symbol <span style={{ color: "red" }}>*</span>
                <span className="text-gray-500 text-xs"> (e.g.$,₹)</span>
              </label>
              <input
                maxLength={5}
                type="text"
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter Currency Symbol"
                value={formData.currencySymbol}
                onChange={(e) => {
                  let value = e.target.value.replace(/[a-zA-Z0-9]/g, ""); // Remove letters & numbers
                  setFormData({ ...formData, currencySymbol: value });
                }}
              />
              {requireErrorMessage && formData.currencySymbol === "" && (
                <label className="validation">{ERROR_MESSAGES}</label>
              )}
            </div>
          </div>

          {errorMessage && (
            <div className="text-center">
              <label className="validation">{errorMessage}</label>
            </div>
          )}

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 rounded-b-lg border-t flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 bg-gray-300 rounded-md text-sm"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-sm"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>

        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={() => {
            onClose();
            setShowSuccessPopupModal(false);
          }}
          modelAction={modelAction}
          actionMessage={formData.countryName}
        />
      </div>
    </div>
  );
};

export default AddUpdateCountryModal;
